<template>
  <v-container>
    <v-card v-if="isErrorParam" flat outlined class="ma-5 pa-3">
      <div class="subtitle-2 mb-2">
        <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
        <span class="primary--text">分析・診断サービス申し込み情報にアクセスできません</span>
      </div>
      <p class="caption">
        分析・診断サービス申し込み情報にアクセスできません。<br>
        <br>
        すでに削除されている申し込み情報を開こうとしているか、他の事業所の申し込み情報にアクセスしています。<br>
        もう一度お申込みページからアクセスしてください。<br>
      </p>
      <v-btn icon :to="{ path: '/' }">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>お申込みページに戻る
    </v-card>

    <div v-if="!isErrorParam" class="nonprint">
        <v-btn icon :to="returnPath">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <span class="display-1 px-3">分析・診断サービス申込書</span>
    </div>

    <v-card v-if="!isErrorParam" flat outlined class="pa-3 nonprint">
      <div class="subtitle-2 mb-2">
        <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
        <span class="primary--text">送付していただく分析依頼品についてのお願い</span>
      </div>
      <p class="title-1">
        「お申込書」を印刷して弊社まで送付してください。<br>
        <br>
        （１）<strong>お申込書</strong>を印刷してください。<br>
        （２）<strong>Ａ票（１ページ目）を切り取り線で切り離して、分析依頼物の外箱に貼り付けて</strong>ください。<br>
        （３）<strong>Ｂ票（２ページ目以降）は分析依頼物に同梱して</strong>ください。<br>
        （４）分析サンプルのボトルに、<strong>サンプルバーコード</strong>を貼り付けてください。<br>
      </p>
      <v-btn 
        small 
        rounded 
        color="amber" 
        @click="barcodePrint()"
        class="mx-3 mt-5"
        id="ordersheet_btn"
        >
        <v-icon class="mr-2">mdi-printer</v-icon>
        お申込書を印刷する
      </v-btn>
      <v-btn 
        small 
        class="mx-3 mt-5"
        rounded 
        color="amber" 
        id="barcodesheet_btn"
        :to="{ path: '/barcodesheet', query: { id: this.applicationid }}"
        >
        <v-icon class="mr-2">mdi-barcode</v-icon>
        サンプルバーコードを印刷する
      </v-btn>
      <p class="mx-3 mt-3 caption">
        ※ご利用の環境（OSやブラウザのバージョンやプリンターなど）によって印刷レイアウトが崩れる場合があります。印刷レイアウトが崩れる場合は、お手数ですが余白や印刷範囲を設定して印刷してください。
      </p>
    </v-card>

    <div v-if="!isErrorParam" class="mt-3">
      <v-card flat class="pa-0" width="210mm" style="margin: 0 auto">
<!--
      <v-card class="px-3">
-->
        <div class="onlyprint" style="border: 2px solid; width:50px; text-align:center">Ａ</div>
        <v-card-title class="printable-title font-weight-bold">
          <span>ジャパン・アナリスト株式会社</span>
          <span class="ml-5">分析・診断サービス申込書
          </span>
          <span class="ml-5 onlyprint">（外箱貼り付け用）
          </span>
        </v-card-title>
<!--
        <v-row dense class="mt-1 px-5">
          <v-col cols="12" class="mx-5"  id="printable-caption" dense>
            <span>{{ application.Name }}</span><br>
          </v-col>
        </v-row>
-->
        <v-row dense class="mt-1 px-5">
          <v-col cols="6" dense class="mx-5 printable-caption">
            <span>お申込み日 : {{ application.createdAt| moment('YYYY[年]MM[月]DD[日]') }}</span><br>
            <span>予約番号 : {{ application.id }}</span><br>
            <span v-show="application.OrderNumber">受注番号 : {{ application.OrderNumber }}<br></span>
            <span v-show="!application.OrderNumber">受注番号 : 採番待ち<br></span>
            <span>分析サンプル数 : {{ application.SampleCount }} サンプル</span><br>
          </v-col>
          <v-col cols="5" dense>
            <span class="title px-3">WEB予約番号バーコード</span>
            <barcode v-model="barcodeValue" format='CODE128' height=60 width=1>Show this if the rendering fails.</barcode>
          </v-col>
        </v-row>
        <hr class="perforatedline onlyprint">
        <v-divider class="mt-3 nonprint"></v-divider>
        <div class="pagebreak"></div>

        <div class="onlyprint" style="border: 2px solid; width:50px; text-align:center">Ｂ</div>

        <v-row dense class="mt-2 px-5">
          <v-col cols='12' class="onlyprint printable-title font-weight-bold">
            <span>ジャパン・アナリスト株式会社</span>
            <span class="ml-5">分析・診断サービス申込書（同梱用）
            </span>
          </v-col>
        </v-row>

        <div class="onlyprint">
          <v-row dense class="mt-2 px-5">
            <v-col cols="5" dense class="mx-5 printable-caption">
              <span>お申込み日 : {{ application.createdAt| moment('YYYY[年]MM[月]DD[日]') }}</span><br>
              <span>予約番号 : {{ application.id }}</span><br>
              <span>注文番号 : {{ application.CustomerOrderNumber }}</span><br>
              <span v-show="application.OrderNumber">受注番号 : {{ application.OrderNumber }}<br></span>
              <span v-show="!application.OrderNumber">受注番号 : 採番待ち<br></span>
              <span>分析サンプル数 : {{ application.SampleCount }} サンプル</span><br>
            </v-col>
            <v-col cols="5" dense class="mx-5 printable-caption">
              <span class="title px-3">WEB予約番号バーコード</span>
              <barcode v-model="barcodeValue" format='CODE128' height=60 width=1>Show this if the rendering fails.</barcode>
            </v-col>
          </v-row>
          <v-divider class="mt-3 "></v-divider>
        </div>

        <v-row dense class="mt-2 px-5">
          <v-col cols='6'>
            <span class="printable-card-title font-weight-bold">報告書／納品明細書送付先</span>
                <v-card flat class="pa-1 mt-2  printable-card-body">
                  {{ delvOffice.Zip }} {{ delvOffice.Address1 }} {{ delvOffice.Address2 }} {{ delvOffice.Address3 }}<br>
                  {{ application.DelvCompany }} {{ application.DelvOffice }}<br>
                  {{ application.DelvDept }} <span class="font-weight-bold">{{ application.DelvPIC }}</span><span v-if="(application.DelvPIC)"> 様</span><br>
                  TEL：{{ delvOffice.Tel }}<br>
                  FAX：{{ delvOffice.FAX }}<br>
                  email：<span v-if="(delvEmployee)">{{ delvEmployee.email }}</span><br>
                </v-card>
          </v-col>
          <v-col cols='6'>
            <span class="printable-card-title font-weight-bold">報告書宛名</span>
                <v-card flat class="pa-1 mt-1  printable-card-body">
                  {{ application.RepCompany }} {{ application.RepOffice }}<br>
                  {{ application.RepDept }} <span class="font-weight-bold">{{ application.RepPIC }}</span> <span v-if="(application.RepPIC)"> 様</span><br>
                </v-card>
          </v-col>
        </v-row>

        <v-divider class="mt-3 "></v-divider>
<!--
        <v-row dense class="mt-2 px-5">
          <v-col cols='6'>
            <span class="printable-card-title font-weight-bold">分析依頼者（納品明細書送付先）</span>
                <v-card flat class="pa-1 mt-1 printable-card-body">
                  {{ payOffice.Zip }} {{ payOffice.Address1 }} {{ payOffice.Address2 }} {{ payOffice.Address3 }}<br>
                  {{ application.PayCompany }} {{ application.PayOffice }}<br>
                  {{ application.PayDept }}
                  <span class="font-weight-bold">{{ application.PayPIC }}</span> <span v-if="(application.PayPIC)"> 様</span><br>
                  TEL：{{ payOffice.Tel }}<br>
                  FAX：{{ payOffice.FAX }}<br>
                </v-card>
          </v-col>
        </v-row>
-->
        <v-divider class="mt-3 "></v-divider>
        <v-row dense>
          <v-col cols='12' class="mt-3">
            <span class="title font-weight-bold">サンプル情報</span>
          </v-col>
          <v-col cols='12'>
            <div v-for="(item, index) of samples" v-bind:key="item.id">
              <v-card class="mb-3">
<!--                <div class="grey darken-3 pa-1 mb-1 white--text sample-title"> -->
                <div class="grey darken-3 mb-1 px-1 white--text" style="width: 100%">
                  <span class="sample-name">{{ item.Name }}</span>
                </div>
                <div class="px-4 sample-body">
<!--                  <span class="body-2">採取日：</span><span class="body-2" v-html="item.SamplingAt"></span> -->
                  <span class="body-1">サンプル：</span><span class="body-1">[ <b>{{ numSampleID(item.SampleID) }} </b>] </span>
                  <span class="body-1">採取日：</span><span class="body-1" v-html="item.SamplingAt"></span>
                </div>
<!--                
                <div class="px-4 sample-body">
                  <span class="body-2">分析項目：</span><span class="body-2" v-html="item.AnalizeItemName"></span>
                </div>
-->
                
                <div class="px-4 sample-body">
<!--                
                  <span v-show="item.DeliveryPeriod" class="body-2 mr-3">指定納期日：{{ item.DeliveryPeriod }}</span>
                  <span v-show="!item.DeliveryPeriod" class="body-2 mr-3">指定納期日：指定なし</span>
-->

                  <span class="body-2 mr-3">サンプルボトル数：{{ item.BottleCount }}</span>
                  <span class="body-2">サンプル量：{{ item.Quantity }} mL</span>
                </div>
                <div class="px-4 sample-body">
                  <span class="body-2 mr-3">オイルの種類：{{ item.OilTypeCategoryText }}（{{ item.OilTypeText }}）</span>
                  <span class="body-2">オイル使用時間：{{ item.OilUsageTime }} {{ item.OilUsageTimeUnitText }}</span>
                </div>
                <div class="px-4 sample-body" v-show="item.isHazardousMaterials == '1'">
                  <span class="body-2 mr-3">危険物あり</span>
                  <span class="body-2 mr-3">問い合わせ番号：{{item.TrackingNumber}}</span>
                </div>
                <div class="px-4 sample-body">
                  <span class="body-2">分析項目：</span><span class="body-2" v-html="item.AnalizeItemName"></span>
                </div>
                <div>
                  <barcode :value="item.id" format='CODE128' height=55 width=1>バーコードの作成に失敗しました</barcode>
                </div>
                <v-divider class="mt-3 onlyprint"></v-divider>
              </v-card>
              <div class="pagebreak" v-if="index==0&&application.SampleCount > 1"></div>
              <div class="pagebreak" v-if="index>0&&(index%3) == 0"></div>
            </div>
          </v-col>
        </v-row>

        <v-overlay absolute :value="overlayStepper1" opacity="0.8" color="white">
          <v-progress-circular indeterminate size="64" color="amber"></v-progress-circular>
        </v-overlay>

      </v-card>
    </div>
  </v-container>
</template>

<script>
import VueBarcode from 'vue-barcode';
//import moment from 'moment'
import { API, graphqlOperation} from "aws-amplify"
import { getApplication, samplesByApplication } from '../graphql/queries'
import { officeByKey } from '../graphql/queries'
import { employeeByKey } from '../graphql/queries'
import mixin  from '../utils/mixin.js'

export default {
  components: {
    'barcode': VueBarcode
  },
  mixins:[mixin],
  head: {
    title: { inner: '分析依頼書'},
  },
  data: () => ({
    barcodeValue: '1234567890',
    applicationid: "",
    application: {},
    delvOffice: {},
    payOffice: {},
    delvEmployee: {},
    payEmployee: {},
    samples: [],
    sampleNum: 0,
    overlayStepper1: true,
    isErrorParam: false,
    ErrorInfo: "",
  }),
  mounted: async function () {
    this.applicationid = this.$route.query.id
    let application = await API.graphql(graphqlOperation(getApplication, {id: this.applicationid}))

      // 参照依頼情報のアクセスチェック
      // 存在しない依頼情報、他事業所の依頼情報を開いた場合はアクセス不正でエラーにする
      if(!application.data.getApplication) {
        this.isErrorParam = true
        this.ErrorInfo = "notExist"
        this.overlayStepper1 = false
        console.log('isErrorParam: ', this.isErrorParam)
        return
      }
      if(this.$store.state.isStaff == false) {
        if(application.data.getApplication.OfficeID != this.$store.state.operatingOffice.OfficeID) {
          this.isErrorParam = true
          this.ErrorInfo = "illegalAccess"
          this.overlayStepper1 = false
          console.log('isErrorParam: ', this.isErrorParam)
          return
        }
      }

    this.application = application.data.getApplication

    // samplesByApplicationクエリを使用してサンプル一覧を取得
    const samplesResult = await API.graphql(graphqlOperation(samplesByApplication, {ApplicationID: this.applicationid}))
    let _samples = samplesResult.data.samplesByApplication.items
    _samples.sort(function(a,b){
        if(a.SampleID < b.SampleID) return -1;
        if(a.SampleID > b.SampleID) return 1;
        return 0;
    });
    this.samples = _samples

    let _delvOffice = await API.graphql(graphqlOperation(officeByKey, {OfficeID: this.application.DelvCompanyID + this.application.DelvOfficeID}))
    this.delvOffice = _delvOffice.data.officeByKey.items[0]

    let _payOffice = await API.graphql(graphqlOperation(officeByKey, {OfficeID: this.application.PayCompanyID + this.application.PayOfficeID}))
    this.payOffice = _payOffice.data.officeByKey.items[0]

    let _delvEmployee = await API.graphql(graphqlOperation(employeeByKey, {EmployeeID: this.application.DelvCompanyID + this.application.DelvOfficeID + this.application.DelvEmployeeID}))
    this.delvEmployee = _delvEmployee.data.employeeByKey.items[0]

    let _payEmployee = await API.graphql(graphqlOperation(employeeByKey, {EmployeeID: this.application.PayCompanyID + this.application.PayOfficeID + this.application.PayEmployeeID}))
    this.payEmployee = _payEmployee.data.employeeByKey.items[0]

    this.barcodeValue = this.applicationid
    this.sampleNum = this.samples.length

    if (this.samples) {
//      this.samples.forEach((value, index) => {
      for (const value of _samples) {
//        const analyseItemByType = this.$store.state.analizeItemList.filter(item => item.AnalizeType  == value.AnalizeType)
//        const analyseSetByType = this.$store.state.analizeSetList.filter(item => item.AnalizeType  == value.AnalizeType)
        let analizeSetList = await this.getAnalizeSetList(value.AnalizeType)
        let analizeItemList = await this.getAnalizeItemList(value.AnalizeType)
        let analizeItemSubList = await this.getAnalizeItemSubList(value.AnalizeType)

        var analyzeTypeNames = []

        // setの分析項目名取得 value.AnalizeSet
        if (value.AnalizeSet) {
//          const analyseItemBySet = analyseSetByType[0].AnalizeSets.filter(item => item.Value  == value.AnalizeSet)
          let analizeSet = analizeSetList.filter(item => item.Value  == value.AnalizeSet)

//          analyzeTypeNames.push(analyseItemBySet[0].Text + "（" + JSON.parse(analyseItemBySet[0].AnalizeItemNames) + "）")
          analyzeTypeNames.push(analizeSet[0].Text + "（" + JSON.parse(analizeSet[0].AnalizeItemNames) + "）")
        }
        // 個別の分析項目名取得
        var analizeItems = ''
        try {
          analizeItems = JSON.parse(value.AnalizeItems)
        } catch (e) {
          const replaced = value.AnalizeItems.replace(/'/g,"\"")
          analizeItems = JSON.parse(replaced)
        }

        let analizeItemSub = JSON.parse(value.AnalizeItemSub)
        if (analizeItems) {
          for (const analizeItem of analizeItems) {
            let item = analizeItemList.filter(item => item.Value  == analizeItem)
            if(item[0]) {
              analyzeTypeNames.push(item[0].Text)
            }else {
              analyzeTypeNames.push(analizeItem)
            }

            if(analizeItemSub) {
              let _analizeItemSub = analizeItemSub[analizeItem]
              if(_analizeItemSub) {
                let _analizeItemSubList = analizeItemSubList[analizeItem]
                for (const _analizeItem of _analizeItemSub) {
                  let item = _analizeItemSubList.filter(item => item.Value  == _analizeItem)
                  if(item[0]) {
                    analyzeTypeNames.push(item[0].Text)
                  }else {
                    analyzeTypeNames.push(analizeItem)
                  }
                }
              }
            }
          }


/*
          analizeJSON.forEach(valuem => {
            const analiseTypeName = analyseItemByType[0].AnalizeItems.filter(item => item.Value  == valuem)
//            analyzeTypeNames = analyzeTypeNames + ',' + analiseTypeName[0].Text
            if(analiseTypeName[0]) {
              analyzeTypeNames.push(analiseTypeName[0].Text)
            }else{ // 分析項目のデータがなくなった
              analyzeTypeNames.push(valuem)
            }

          })
*/
        }
//        this.samples[index].AnalizeItemName = analyzeTypeNames.slice(1)
//        this.samples[index].AnalizeItemName = analyzeTypeNames.join(",")
        value.AnalizeItemName = analyzeTypeNames.join(",")
      }
    }
    console.log('samples', this.samples)
    this.overlayStepper1 = false    
  },
  computed: {
    returnPath() {
      return { path: '/ordersheet4labelsheet', query: { id: this.applicationid }}
    }
  },
  methods: {
    numSampleID (sampleid) {
      return ( '000' + Number(sampleid) ).slice( -3 );
    },
    barcodePrint: async function () {
      // window.document.body.innerHTML = document.getElementById(
      //   'printable'
      // ).innerHTML     
      window.print()
      // this.$router.go({path: this.$router.currentRoute.path, force: true})
      // this.$router.push('/mymachine')
      // this.$router.push("/mymachinelist");
      // window.location.reload();
    },

  },

//  filters: {
//   moment: function (date) {
//        return moment(date).format('YYYY/MM/DD HH:mm');// eslint-disable-line
//    }
//  }
}
</script>
<style lang="scss" scoped>
  .onlyprint { 
    display: none;
  }

.perforatedline {
  border: 0;
  border-top: 2px dashed #000;
  text-align: center;
  margin-top: 50px;
}
 
.perforatedline:after {
  background: #fff;
  content: '\002702  キ リ ト リ 線  \002702';
  display: inline-block;
  padding: 0 0.5em;
  position: relative;
  top: -0.7em;
}

.sample-name  {
  padding: 8px;
  width: 100%;
}

@media print {
  .nonprint { 
    display: none;
  }
  .printable-caption {
    font-size : 12px !important;
    margin: 0px !important;
  }
  .printable-title {
    font-size : 18px;
    padding: 10px 5px 5px;
  }
  .printable-card-title {
    font-size : 16px !important;
  }
  .printable-card-body {
    font-size : 10px !important;
  }
  .sample-name  {
    padding: 8px !important;
    width: 100% !important;
    font-size : 13px !important;
    color: #000;
  }
  .sample-body  {
    font-size : 10px !important;    
  }
  .v-toolbar {
    display: none;
  }
  .v-content {
    padding: 0px !important;
  }
  .container {
    padding: 0px !important;
  }
  .v-sheet {
    padding: 0px !important;
  }
  .v-card {
    box-shadow: none !important ;
  }
  .pagebreak {
    break-after: page;
  }
  .onlyprint { 
    display: block;
  }
}
</style>